import { Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material'
import { t } from 'i18next'


const GatewayStatus = ({ filters, onChange }) => {
  const technology = filters?.technology || []

  const handleChange = ({ target: { name } }) => {
    const newTechnology = technology.includes(name)
      ? technology.filter((s) => s !== name)
      : technology.concat(name)
    onChange({ technology: newTechnology })
  }

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        spacing={2}
        mt={3}
        mb={3}
      >
        <Typography
          id="gateway-technology-label"
          align="left"
          sx={{ fontWeight: 'bold' }}
        >
          {t('filters.gateways.technology.label')}
        </Typography>
        <FormGroup
          row
        >
          <FormControlLabel
            id="gateway-technology-lorawan-label"
            value="Lorawan"
            control={
              <Checkbox
                name="Lorawan"
                onChange={handleChange}
                aria-labelledby="gateway-technology-label"
                checked={technology.includes('Lorawan')}
              />
            }
            label={t('filters.gateways.technology.lorawan')}
          />
          <FormControlLabel
            id="gateway-technology-wmbus-label"
            value="Wmbus"
            control={
              <Checkbox
                name="Wmbus"
                onChange={handleChange}
                aria-labelledby="gateway-technology-label"
                checked={technology.includes('Wmbus')}
              />
            }
            label={t('filters.gateways.technology.wmbus')}
          />
          <FormControlLabel
            id="gateway-technology-wmbus-lorawan-label"
            value="Wmbus+Lorawan"
            control={
              <Checkbox
                name="Wmbus+Lorawan"
                onChange={handleChange}
                aria-labelledby="gateway-technology-label"
                checked={technology.includes('Wmbus+Lorawan')}
              />
            }
            label={t('filters.gateways.technology.dual')}
          />
        </FormGroup>
      </Stack>
    </>
  )
}

export default GatewayStatus
